module.exports = __webpack_public_path__ + "img/P150T_weapon_146.068aa100.png";